import React from 'react'
import {
  RichDropdownMenu,
  type RichMenuOption
} from '~/components/common/dropdowns/RichDropdownMenu'
import { Typography } from '~/components/common/Typography'

export type AgentMode = 'agent' | 'ask'
export type SpeedMode = 'fast' | 'verify'

interface ModeDropdownProps {
  label: string
  options: RichMenuOption[]
  selectedValue: string
  onSelect: (value: string) => void
  disabled?: boolean
  showBorder?: boolean
  /** Alignment of dropdown content relative to trigger: 'start' (left), 'center', 'end' (right) */
  align?: 'start' | 'center' | 'end'
  rotateArrowOnOpen?: boolean
}

export const ModeDropdown: React.FC<ModeDropdownProps> = ({
  label,
  options,
  selectedValue,
  onSelect,
  disabled = false,
  showBorder = false,
  align = 'start',
  rotateArrowOnOpen = false
}) => {
  const selectedOption = options.find(opt => opt.value === selectedValue)
  const [open, setOpen] = React.useState(false)

  return (
    <RichDropdownMenu
      options={options}
      selectedValue={selectedValue}
      onSelect={onSelect}
      open={open}
      onOpenChange={setOpen}
      disabled={disabled}
      align={align}
      trigger={
        <button
          className={`flex items-center gap-1.5 px-3 py-2 transition-colors outline-none select-none min-w-0 max-w-full
            ${open ? 'bg-gray-100' : ''}
            ${showBorder ? 'rounded-2xl border border-tokens-neutral-border-2' : 'rounded-lg'}
            ${disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'hover:bg-gray-100'}
            ${rotateArrowOnOpen ? '[&[data-state=open]>svg]:rotate-180' : ''}
          `}
        >
          <Typography
            fontFamily='geist'
            fontSize='bodySm'
            fontWeight='medium'
            className='text-tokens-neutral-text-secondary leading-[16px] truncate'
          >
            {selectedOption?.label || label}
          </Typography>
          <svg
            width='12'
            height='12'
            viewBox='0 0 12 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='shrink-0 transform transition-transform duration-200'
          >
            <path
              d='M3 4.5L6 7.5L9 4.5'
              stroke='rgba(0,0,0,0.45)'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </button>
      }
    />
  )
}
